import { Table } from 'shared/ui/Table/Table'
import React from 'react'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import {
  activityNodeMapAtom,
  destTreeIdMap,
  unMappedActivityNodes,
} from './atoms'
import {
  cellForType,
  getNodeRowDataAsString,
  nodePathCell,
  openKiddomCell,
  titleCell,
} from './tableColumns'
import { NodeType } from 'shared/types/ingestion'
import { Column } from 'shared/ui/Table/types'

export function MissingMapping() {
  const columns = useTreeColumns()
  const items = useAtomValue(unMappedActivityNodes)

  if (!items.length) return null

  return (
    <Table<string>
      title={`Missing Mapping: ${items.length}`}
      columns={columns}
      items={items}
      canExport={true}
    />
  )
}

function useTreeColumns(): Column<string>[] {
  const mapped = useAtomValue(activityNodeMapAtom)
  const idMap = useAtomValue(destTreeIdMap)
  return [
    {
      title: 'Title',
      rowContent: titleCell(idMap),
      rowString: getNodeRowDataAsString({
        destIdMap: idMap,
        nodeMapping: mapped,
        dataType: 'title',
      }),
    },
    {
      title: 'Node Path',
      rowContent: nodePathCell(idMap),
      rowString: getNodeRowDataAsString({
        destIdMap: idMap,
        nodeMapping: mapped,
        dataType: 'path',
      }),
    },
    {
      title: 'Unit',
      rowContent: cellForType(NodeType.Unit, idMap),
      rowString: getNodeRowDataAsString({
        destIdMap: idMap,
        nodeMapping: mapped,
        dataType: 'unit',
      }),
    },
    {
      title: 'Lesson Plan',
      rowContent: cellForType(NodeType.LessonPlan, idMap),
      rowString: getNodeRowDataAsString({
        destIdMap: idMap,
        nodeMapping: mapped,
        dataType: 'lesson',
      }),
    },
    {
      title: 'Title Match Count',
      rowContent: (nodeId: string) => {
        return mapped[nodeId]?.length
      },
      rowString: (nodeId: string) => {
        return String(mapped[nodeId]?.length)
      },
    },
    {
      title: 'Kiddom',
      rowContent: openKiddomCell(idMap),
      rowString: getNodeRowDataAsString({
        destIdMap: idMap,
        nodeMapping: mapped,
        dataType: 'url',
      }),
    },
  ]
}
